import { useCallback, useEffect, useRef, useState } from 'react'

/** A short client-side debounce for "resend code" buttons — Cognito enforces the real
 *  rate limit, this just stops an eager double-tap from firing two requests. */
export function useResendCooldown(seconds = 5) {
  const [cooling, setCooling] = useState(false)
  const timer = useRef<ReturnType<typeof setTimeout> | undefined>(undefined)

  useEffect(() => () => clearTimeout(timer.current), [])

  const start = useCallback(() => {
    setCooling(true)
    clearTimeout(timer.current)
    timer.current = setTimeout(() => setCooling(false), seconds * 1000)
  }, [seconds])

  return { cooling, start }
}
